import { z } from 'zod'
import type { FormResponsePayload } from '@omnea-app/packages/universal/formBuilder/form'

export const FixedWorkflowFileReferenceSchema = z.object({
  type: z.literal('file'),
  fileStoreId: z.string(),
  filename: z.string(),
})

export type FixedWorkflowFileReference = z.infer<typeof FixedWorkflowFileReferenceSchema>

export const DynamicWorkflowFileReferenceSchema = z.object({
  type: z.literal('dynamic'),
  questionId: z.string(),
})

export type DynamicWorkflowFileReference = z.infer<typeof DynamicWorkflowFileReferenceSchema>

export const WorkflowFileReferenceSchema = z.discriminatedUnion('type', [
  FixedWorkflowFileReferenceSchema,
  DynamicWorkflowFileReferenceSchema,
])

export type WorkflowFileReference = z.infer<typeof WorkflowFileReferenceSchema>

export const resolveWorkflowFileReferences = (
  references: WorkflowFileReference[] | undefined,
  answers: FormResponsePayload
): FixedWorkflowFileReference[] =>
  (references ?? []).flatMap((reference) => {
    if (reference.type === 'file') return [reference]

    const answer = answers[reference.questionId]
    if (answer?.type !== 'files') return []

    return answer.value.map(
      (file) => ({ type: 'file', fileStoreId: file.key, filename: file.filename }) satisfies FixedWorkflowFileReference
    )
  })

export const findUnknownQuestionReferences = (references: WorkflowFileReference[], knownQuestionNames: Set<string>): string[] => [
  ...new Set(
    references.flatMap((reference) =>
      reference.type === 'dynamic' && !knownQuestionNames.has(reference.questionId) ? [reference.questionId] : []
    )
  ),
]
